import { Component, EventEmitter, Input, Output, OnInit, OnChanges } from '@angular/core';
import { Message, ModalOpenerService } from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../../../core/classes/modal-types.enum';

@Component({
  selector: 'app-announcement-list',
  templateUrl: './announcement-list.component.html',
  styleUrls: ['./announcement-list.component.scss'],
  standalone: false
})
export class AnnouncementListComponent implements OnInit, OnChanges {
  @Input() announcements: Message[] = [];
  @Input() showTravelAdviceCondition = false;
  @Input() checkboxId = 'suppress_announcement';

  @Output() deleteAnnouncementEvent = new EventEmitter<string>();
  @Output() suppressAnnouncementEvent = new EventEmitter<string>();

  displayedMessagesGrouped: { categoryName: string; messages: Message[] }[] = [];
  totalMessageCount = 0;
  messageTruncateLength = 370;

  constructor(private modalService: ModalOpenerService) {}

  onDeleteAnnouncement(id: string): void {
    this.deleteAnnouncementEvent.emit(id);
  }

  onSuppressAnnouncement(id: string): void {
    this.suppressAnnouncementEvent.emit(id);
  }

  ngOnInit() {
    this.updateDisplayedMessages();
  }

  ngOnChanges() {
    this.updateDisplayedMessages();
  }

  updateDisplayedMessages(): void {
    // Group all messages by category
    const allCategoriesGrouped: { [key: string]: Message[] } = {};

    if (this.announcements && typeof this.announcements === 'object') {
      Object.keys(this.announcements).forEach((key) => {
        const categoryMessages = (this.announcements as any)[key];
        if (Array.isArray(categoryMessages) && categoryMessages.length > 0) {
          const categoryName = categoryMessages[0].name;
          if (!allCategoriesGrouped[categoryName]) {
            allCategoriesGrouped[categoryName] = [];
          }
          allCategoriesGrouped[categoryName].push(...categoryMessages);
        }
      });
    }

    // Count total messages
    this.totalMessageCount = Object.values(allCategoriesGrouped).reduce(
      (sum, msgs) => sum + msgs.length,
      0
    );

    // Show only the first message from the first category
    this.displayedMessagesGrouped = [];
    const firstCategoryKey = Object.keys(allCategoriesGrouped)[0];

    if (firstCategoryKey) {
      let messages = allCategoriesGrouped[firstCategoryKey];

      // If first message is large, show only first message; otherwise show max 2
      if (messages[0]?.config?.message?.length > this.messageTruncateLength) {
        messages = [messages[0]];
      } else {
        messages = messages.slice(0, 2);
      }

      this.displayedMessagesGrouped.push({
        categoryName: firstCategoryKey,
        messages
      });
    }
  }

  openAllMessagesModal(): void {
    this.modalService
      .open(
        LightningModalTypes.AnnouncementModalComponent,
        {},
        {
          announcements: this.announcements,
          showTravelAdviceCondition: this.showTravelAdviceCondition,
          checkboxId: this.checkboxId
        }
      )
      .then((result: { action: string; id: string }) => {
        if (result?.action === 'delete') {
          this.onDeleteAnnouncement(result.id);
        } else if (result?.action === 'suppress') {
          this.onSuppressAnnouncement(result.id);
        }
      })
      .catch(() => {});
  }
}
